<template>
  <div class="flex flex-col md:flex-row md:flex-wrap">
    <!-- 参加条件 -->
    <div class="mb-10 px-0 md:mb-7 md:w-1/2 md:pr-7">
      <div class="text-center md:ml-3.5 md:text-left">
        <span class="text-[0.625rem] leading-normal text-[#1ca7f6]">
          Entry Condition
        </span>
        <h4 class="mb-2 text-[1.25rem] font-bold leading-normal md:mb-3 md:text-[1.5rem]">
          参加条件
        </h4>
      </div>
      <ul class="list-disc pl-5">
        <li class="mb-2">
          受講開始時およびキャリア相談の開始時に企業等と雇用契約がある方
        </li>
        <li class="mb-2">
          必要な各種書類提出への協力
        </li>
        <li class="mb-2">
          当サービスが提供するキャリア相談/面談への参加
        </li>
        <li class="mb-2">
          当サービスが提供するキャリア支援サービスでの転職活動
        </li>
        <li class="mb-2">
          就職後のフォローアップに伴う個人情報を含む必要情報等の提出への協力
        </li>
        <li>
          お申し込みから受講開始日までにアンケート・キャリア相談に対応いただく
        </li>
      </ul>
    </div>

    <!-- 受給条件 -->
    <div class="mb-10 px-0 md:mb-7 md:w-1/2 md:pl-7 md:pr-0">
      <div class="text-center leading-normal md:ml-3.5 md:text-left">
        <span class="text-[0.625rem] leading-normal text-[#1ca7f6]">
          Receiving Condition
        </span>
        <h4 class="mb-2 text-[1.25rem] font-bold leading-normal md:mb-3 md:text-[1.5rem]">
          受給条件
        </h4>
      </div>
      <ul class="list-disc pl-5">
        <li class="mb-2">
          補助対象となるリスキリング講座をお申し込み
        </li>
        <li class="mb-2">
          受講したコースの修了。以下の条件を全て満たしている
        </li>
        <li class="mb-2">
          課題をすべて提出し合格
        </li>
        <li class="mb-2">
          受講中にキャリアカウンセリングを規定回数の実施
        </li>
        <li class="mb-2">
          本人名義でのお申し込み・受講料のお支払い
        </li>
        <li>
          転職先への入社日までに、上記受給条件を全て満たしていること
        </li>
      </ul>
    </div>

    <!-- 注意事項 -->
    <div class="px-0 md:w-1/2 md:pr-7">
      <div class="text-center leading-normal md:ml-3.5 md:text-left">
        <span class="text-[0.625rem] leading-normal text-[#1ca7f6]">
          Notes
        </span>
        <h4 class="mb-2 text-[1.25rem] font-bold leading-normal md:mb-3 md:text-[1.5rem]">
          注意事項
        </h4>
      </div>
      <ul class="list-disc pl-5">
        <li class="mb-2">
          追加サポートを利用してコースを修了した場合、追加サポート費用は補助対象外
        </li>
        <li class="mb-2">
          追加補助の20%について、他サービスで転職された方は対象外
        </li>
        <li class="mb-2">
          転職をご希望の場合、34歳以下を推奨させていただいております。また、転職を保証するものではございません。（転職保証コースを除く）
        </li>
        <li class="mb-2">
          弊社では当制度のご利用に関する個別のご意見やご要望をお受けすることができません
        </li>
        <li class="mb-2">
          当制度の手続き上、お申し込み後の内容変更はできませんのでご注意ください
        </li>
        <li>
          リスキリング対象の講座を複数ご受講いただいた場合でも、補助制度をご申請いただけるのは、いずれか1コースのみです（セット講座においては、そのセット内の複数講座が補助の対象となります）
        </li>
      </ul>
    </div>
  </div>
</template>
